import { useEffect, useState, useRef } from "react";

import styles from "@/styles/components.module.scss";

interface ScrollButtonProps {
    scrollLength: number;
};

const ScrollButton = ({ scrollLength }: ScrollButtonProps) => {
    const [showScroll, setShowScroll] = useState<boolean>(false);
    const buttonMount = useRef<boolean>(false);

    // useEffect(() => {
    //     buttonMount.current = false;
    // }, []);

    useEffect(() => {
        buttonMount.current = false;

        if (!buttonMount.current) {
            window.onscroll = () => showScrollButton();
            
            return () => {
                buttonMount.current = true;
            };
        }

    });

    const showScrollButton = () => {
        if (document.body.scrollTop > scrollLength || document.documentElement.scrollTop > scrollLength) {
            setShowScroll(true);
        } else {
            setShowScroll(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({ behavior: "smooth", top: 0 })
    };

    return (
        !showScroll ? null : <div className={styles[showScroll ? "scroll-box" : "scroll-box--disabled"]}>
            <button 
                className={styles["scroll-btn"]} 
                onClick={scrollToTop}
            >^</button>
        </div>
    );
};

export default ScrollButton;
